import React, { useState } from 'react';
import _ from 'lodash';

import Grid from '@mui/material/Unstable_Grid2';
import Box from '@mui/material/Box';

import Loading from '../../components/loading/Loading';

import AlertMsg from '../../components/alert/AlertMsg';

import { yesterday, last7day } from '../../utils/date';

import Summary from './Summary';
import FilterSettings from './FilterSettings';
import MainReport from './MainReport';


const FrontPage = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [userQuery, setUserQuery] = useState([0, 100]);
  const [dateRange, setDateRange] = useState({ startDate: last7day, endDate: yesterday });
  const [summaryData, setSummaryData] = useState({});

  return (
    <Box>
      <Grid container spacing={2} mt={1}>
        <Grid xs={12} md={2}>
          <Summary
            userQuery={userQuery}
            dateRange={dateRange}
            summaryData={summaryData}
            setSummaryData={setSummaryData}
          />
        </Grid>

        <Grid xs={12} md={10}>
          <Box>
            <FilterSettings
              userQuery={userQuery}
              setUserQuery={setUserQuery}
              dateRange={dateRange}
              setDateRange={setDateRange}
              setIsLoading={setIsLoading}
              summaryData={summaryData}
            />
            <MainReport
              userQuery={userQuery}
              dateRange={dateRange}
            />
          </Box>
        </Grid>
      </Grid>

      {/* <ModalComponent
        isLoading={isLoading}
        handleModalSubmit={handleModalSubmit}
        inputErrorMsg={inputErrorMsg}
        setInputErrorMsg={setInputErrorMsg}
      /> */}

      <AlertMsg />

      <Loading
        isLoading={isLoading}
        variant="inside"
      />
    </Box>
  )
}

export default FrontPage;